
// Polyfill per IE11
//https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill

(function(){
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent (event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent( 'CustomEvent');
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();


$(document).ready(function(){


    // Anchor scroll with fixed header
    $('body').on('click','a[href^="#"]',function(event){
        event.preventDefault();
        var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;

        var customoffset = 120 // to balance fixed header height
        $('html, body').animate({
            scrollTop:target_offset - customoffset
        }, 500);
    });



    if (window.matchMedia("(max-width: 991px)").matches) {  

        // mgigli - Predispongo il div dei risultati ricerca
        var form_id = $('.is-search-form-mobile').attr('data-form-id');
        $('.searchForm.is-search-form-mobile').parent().append('<div id="is-ajax-search-result-'+form_id+'" class="is-ajax-search-result"></div>');
        //console.log("min-width: 768px");

        var headerHeight = $('.logoNav').outerHeight();
        var searchFormHeight = parseInt("90px", 10);
        var searchResultPos = headerHeight + searchFormHeight;

        $('div.is-ajax-search-result').css({
            'top': searchResultPos,
            'height' : 'calc(100% - ' + searchResultPos+ 'px)'
        });

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');

            if($('.mobileSearch').hasClass('is-open')){
                $('.mobileSearch').toggleClass('is-open');
                $('body').toggleClass('search-expanded');
            };


        })

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).toggleClass('is-selected');
            //$(this).parent().toggleClass('is-selected');
        });

        // Ricerca
        $('.js-toggleSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').bind('touchmove', function(e){e.preventDefault()});
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };

            $('.mobileSearch').css({
                'top': headerHeight,
                'height' : 'calc(100% - ' + headerHeight+ 'px)'
            });

            $('div.is-ajax-search-result').css({
                'top' : searchResultPos,
                'height' : 'calc(100% - ' + searchResultPos+ 'px)'
            });

            $('.is-ajax-search-items').css({
                'height' : 'calc(100% - 50px)',
                'max-height' : 'calc(100% - 50px)'
            });


            if($('.announcement').hasClass('is-hidden')){
                $('.mobileSearch').css({
                    'top' : headerHeight,
                    'height' : 'calc(100% - ' + headerHeight+ 'px)'
                });
                $('div.is-ajax-search-result').css({
                    'top' : searchResultPos,
                    'height' : 'calc(100% - ' + searchResultPos+ 'px)'
                });

            };
        })


        $('.js-closeSearch').on('click',function(e){
            e.preventDefault();
            $('body').toggleClass('search-expanded').unbind('touchmove');
            $('.mobileSearch').toggleClass('is-open');

            if($('.js-toggleMenu').hasClass('is-open')){
                $('.js-toggleMenu').removeClass('is-open');
                //$(".primaryNav > ul li,.secondaryNav > .contentWrapWide ul li:not('.searchFormWrap')").toggle();
                $('body').toggleClass('nav-expanded');
            };
        })


        $('.js-openFilters').on('click',function(e){
            e.preventDefault();
            $('.filters').slideToggle();
            $('.openToggle').toggleClass('is-open');
        })





        /*     $('.btn-search').on('click',function(e){
            e.preventDefault();
                 $('.searchFormWrap', '.searchForm').show();
        })*/
    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
        

        // Lingue
        $('.js-dropdown').children('span').on('click', function(event){
            event.preventDefault();
            $(this).next('ul').toggle();
        });
        
    
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }


    // Ricerca + suggerimenti

    $("input[type='search']").on('focus', function(){
        $(this).removeAttr('placeholder');
    });

    $(".is-ajax-search input[type='search']").on('focusout', function(){
        $("div.is-ajax-search-result").hide();

    });

    $(".is-ajax-search input[type='search']").on('keyup', function(){
        $(".is-loader-image").show();

        var selected = $(this);

        if(selected.val().length >= 1){
            setTimeout(function() { 
                selected.next(".is-loader-image").hide();
                $("div.is-ajax-search-result").show();
            }
                       , 700);
        }

        else{
            selected.next(".is-loader-image").hide();
            setTimeout(function() { 
                $("div.is-ajax-search-result").hide();    
            }
                       , 700);
        }
    });


    // Apertura form info

    $(".js-open-form").on('click', function(e){
        e.preventDefault();
        $(".infoForm").css('margin-top','-40px').slideDown();
        $(".infoForm").parents('.contentWrapNarrow').find('.js-open-form').css('opacity','0');
    });



    // Slick + slick Lightbox

    /* $('.carousel').slick({
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 3.25,
        slidesToScroll: 3,
        dots:false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2.25,
                    slidesToScroll: 2,
                    infinite: false,
                    dots:false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1.25,
                    slidesToScroll: 1,
                    infinite: false,
                    dots:false,
                }
            }
        ]
    });

    $('.carousel').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });*/


    $('.carouselMasthead').slick({
        dots: false,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 1000,
        autoplay: true,
        autoplaySpeed: 3000,
        lazyLoad: 'ondemand'
    });

    $('.carouselProduct').slick({
        dots:false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand'
    });

    $('.carouselProduct').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });


    $('.carouselMasthead').slickLightbox({
        navigateByKeyboard : true,
        caption: 'caption'
    });



    //Accordion

    var item = document.querySelectorAll('.accordion__item');
    for(var i = 0; i < item.length; i++) {
        item[i].classList.add('js-item');
        //console.log(title[i].classList);
    }

    var title = document.querySelectorAll('.accordion__header');
    for(var i = 0; i < title.length; i++) {
        title[i].classList.add('js-header');
        //console.log(title[i].classList);
    }

    var copy = document.querySelectorAll('.accordion__content');
    for(var i = 0; i < copy.length; i++) {
        copy[i].classList.add('js-content');
        //console.log(copy[i].classList);
    }

    /*$('.accordion .js-content').show();    
    $('.accordion__item .js-header').attr('aria-expanded','true');*/
    $('.accordion .js-content').hide();    
    $('.accordion__item .js-header').attr('aria-expanded','false');

    // Primo elemento aperto
    //$('.accordion .accordion__item:first-child .js-header').toggleClass('active');
    //$('.accordion .accordion__item:first-child .js-content').slideDown();
    //$('.accordion__item:first-child .js-header').attr('aria-expanded','true');



    //var $title = $('.accordion .js-header');

    $('.accordion .js-header').click(function () {
        $(this).next(copy).slideToggle();
        /*$(this).parent().siblings().children().next().slideUp();
        $(this).parent().siblings().children().removeClass('active');*/
        $(this).toggleClass('active');



        // toggle attributi
        if($(this).attr('aria-expanded') == 'true'){
            $(this).attr('aria-expanded','false');
        }

        else if($(this).attr('aria-expanded') == 'false'){
            $(this).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
        }

        return false;

    });

    var $item = $('.accordion .js-item'); // per la tastiera ridefinisco il selettore perché è l'item ad essere focusable a differenza del clic del mouse cha va sull'header



    $item.keydown(function(e){ // usare keydown e non keyup perché così si può sovrascrivere il comportamento di default della space-bar che se selezionata fa scrollare la pagina


        var keyCode = e.keyCode || e.which;


        if(keyCode == 13 || keyCode == 32){    // all'invio o alla space-bar


            $(this).children(title).next(copy).slideToggle();
            $(this).siblings().children().next().slideUp();
            $(this).children(title).toggleClass('active');

            $(this).siblings().children().removeClass('active');


            if($(this).children(title).attr('aria-expanded') == 'true'){
                $(this).children(title).attr('aria-expanded','false');
            }

            else if($(this).children(title).attr('aria-expanded') == 'false'){
                $(this).children(title).attr('aria-expanded','true').siblings().attr('aria-expanded','false');
            }

            return false;
        }

    });

    if (window.matchMedia("(min-width: 992px)").matches){
        /*$('.accordion .accordion__item.accordion__content').show();*/
        $('.accordion .js-content').show();    
        $('.accordion__item .js-header').attr('aria-expanded','true');
    }

     /** Tabs  mappa **/
    //(thanks ALSO to http://codepen.io/jacmaes/pen/miBKI)
    var $titleTabs = $('.tabs .js-header');

    // Activate first tab
    //$('.tabs .tabs__header li:first-child h3').addClass('active');

    $titleTabs.click(function () {               
        var tabId = $(this).attr("aria-controls");
        console.log(tabId);
        $('.js-content').css('display', 'none');
        $('#'+tabId+'.js-content').css('display', 'flex');
        $(this).addClass('active');
        $('.tabs__content').addClass('visible');
        $(this).parent().siblings().children().removeClass('active');
        return false;
    });

    $titleTabs.focus(function(e){
        $(this).next(copy).css('display', 'flex');
        $(this).parent().siblings().children().next().css('display', 'none');
        $(this).addClass('active');
        $('.tabs__content').addClass('visible');
        $(this).parent().siblings().children().removeClass('active');
        $(this).parent().attr('aria-expanded','true').siblings().attr('aria-expanded','false');

    });

    $('.btn-close').on('click', function(e){
        e.preventDefault();
        $('.tabs .js-header').removeClass('active');
        $('.tabs__content').removeClass('visible');

        if (window.matchMedia("(max-width: 991px)").matches){
            $('.tabs .js-content').slideUp();
            $('html, body').animate({
                scrollTop: $(".imgMap").offset().top -50
            }, 750);

            setTimeout(function() {
                $('.tabs').removeClass('open');
            }, 750);
    }
    if (window.matchMedia("(min-width: 992px)").matches){
        $('.tabs .js-content').hide();
    }
    });

    var $mapNumbers = $('.imgMapHints>span');

    /* $mapNumbers.click(function() {  
        var idNumber = $(this).attr("data-number");
        $('.js-content').css('display', 'none');
        $('.tabs__content').addClass('visible');
        $('#panel'+idNumber).css('display', 'flex');
        $('.js-header').removeClass('active');
        $('#tab'+idNumber).addClass('active');
        return false;
    }); */

    
        $mapNumbers.click(function() {     
        var idNumber = $(this).attr("data-number");  
            
        $('.js-content').hide();
        $('.tabs__content').addClass('visible');
        $('.js-header').removeClass('active');
        $('#tab'+idNumber).addClass('active');

        if (window.matchMedia("(max-width: 991px)").matches){
        if($('.tabs').hasClass('open')){
            $('#panel'+idNumber).show();
        }
        else{
            $('#panel'+idNumber).slideDown();
    }
    $('html, body').animate({
        //scrollTop: $(".tabs").offset().top -40
        scrollTop: $(".imgMap").offset().top -50
    }, 750);

    setTimeout(function() {
        $('.tabs').addClass('open');
      }, 750);
      
    return false;
}
if (window.matchMedia("(min-width: 992px)").matches){
    $('#panel'+idNumber).show();
}

            
        });
   

    if (window.matchMedia("(min-width: 992px)").matches){
        $titleTabs.hover(function(){
            var numberTabId = $(this).prop('id');
            $('.imgMapHints span[data-tab='+numberTabId+']').addClass('hovered');
        }, 
        function(){
            var numberTabId = $(this).prop('id');
            $('.imgMapHints span[data-tab='+numberTabId+']').removeClass('hovered');
        });

        $mapNumbers.hover(function(){
            var numberTabId = $(this).attr("data-number");
            console.log(numberTabId);
            $('#tab'+numberTabId).addClass('hovered');
        }, 
        function(){
            var numberTabId = $(this).attr("data-number");
            $('#tab'+numberTabId).removeClass('hovered');
        });
    } 

    // Exit intent popup
    if ($('.exitIntent-popup').length > 0) {
        var options = {
            //debug: true,
            cookieName: 'subscribe-popup',
            cookieValidity: 3,
            delay: 2
        };
        $('.exitIntent-popup').ysExit(options);
    }
});


// Intersection observer per "accendere" voci menu contestuale

let options = {
    //root: document.querySelector('#productExtras'),
    rootMargin: '0px 0px -50% 0px',
    threshold: 0
}


let callback = (entries, observer) => {
    entries.forEach(entry => {
        console.log(entry);
        if(entry.isIntersecting){
            //console.log('metti il pallino su '+entry.target.id);
            addClass(entry.target);
        }
        else{
            //console.log('togli il pallino su '+entry.target.id);
            removeClass(entry.target);
        }
    });

    if($("#anchor1").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor1']").addClass("active");
    }
    if($("#anchor2").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor2']").addClass("active");
    }
    if($("#anchor3").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor3']").addClass("active");
    }
    if($("#anchor4").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor4']").addClass("active");
    }
    if($("#anchor5").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor5']").addClass("active");
    }
    if($("#anchor6").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor6']").addClass("active");
    }
    if($("#anchor7").hasClass('entering')){
        $(".contentWrapAside__menu a").removeClass("active");
        $("a[href$='#anchor7']").addClass("active");
    }
};



function addClass(entry) {
    if (!entry.classList.contains('entering')) {
        entry.classList.add('entering');
    }
}

function removeClass(entry) {
    if (entry.classList.contains('entering')) {
        entry.classList.remove('entering');
    }
}


let observer = new IntersectionObserver(callback, options);
const entries = [].slice.call(document.querySelectorAll('.toObserve'));
entries.forEach(entry => observer.observe(entry)); 

// Store the window width
var windowWidth = $(window).width();

//Resize Event
/* $(window).resize(function(){
    // Check if the window width has actually changed and it's not just iOS triggering a resize event on scroll
    if ($(window).width() != windowWidth) {

        // Update the window width for next time
        windowWidth = $(window).width();

        setTimeout(function(){
            window.location.reload();
        });

    }
}); */

